import React from 'react';

/**
 * Who is Active / Idle / Locked / Offline right now.
 *
 * The backend returns `liveStatus` only when the requested date is the Qatar
 * today, so this renders only then. "Right now" against a past date would be a
 * figure that quietly means something else.
 */

const PILLS = [
    { key: 'active', label: 'Active', background: '#dcfce7', color: '#166534' },
    { key: 'idle', label: 'Idle', background: '#fef3c7', color: '#92400e' },
    { key: 'locked', label: 'Locked', background: '#e2e8f0', color: '#475569' },
    { key: 'suspended', label: 'Sleeping', background: '#e2e8f0', color: '#475569' },
    { key: 'online', label: 'Online', background: '#dcfce7', color: '#166534' },
    { key: 'offline', label: 'Offline', background: '#fee2e2', color: '#991b1b' },
];

export default function LiveStatusStrip({ counts }) {
    if (!counts || !counts.total) return null;

    return (
        <div className="wt-live">
            <span className="wt-live-label">Right now</span>
            {PILLS.filter((p) => counts[p.key] > 0).map((p) => (
                <span
                    key={p.key}
                    className="wt-live-pill"
                    style={{ background: p.background, color: p.color }}
                >
                    <span className="n">{counts[p.key]}</span> {p.label}
                </span>
            ))}
            <span className="wt-live-label">of {counts.total} enrolled laptops</span>
        </div>
    );
}
